import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/landlord/register', component: () => import('@/views/landlord/register'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/profile',
    meta: {title: '个人信息', icon: 'home'},
    hidden: true,
    children: [{
      path: 'profile',
      name: 'profile',
      component: () => import('@/views/profile/index'),
      meta: {title: '个人信息', icon: 'home'},
    }]
  },
  // {path: '/display', component: () => import('@/views/datav/index'), hidden: true},
  {path: '/promotion', component: () => import('@/views/promotion/index'), hidden: true},
  {path: '/promotion/uploadVideo', component: () => import('@/views/promotion/uploadVideo'), hidden: true},
  {path: '/dashboard-new', component: () => import('@/views/dashboard/index'), hidden: true},
  
  // {
  //   path: '',
  //   component: Layout,
  //   redirect: '/home',
  //   meta: {title: '首页', icon: 'home'},
  //   children: [{
  //     path: 'home',
  //     name: 'home',
  //     component: () => import('@/views/home/default'),
  //     meta: {title: '首页', icon: 'home'}
  //   }],
  // }
  // {
  //   path: '',
  //   component: Layout,
  //   redirect: '/home',
  //   meta: {title: '首页', icon: 'home'},
  //   children: [{
  //     path: 'home',
  //     name: 'home',
  //     component: () => import('@/views/home/default'),
  //     meta: {title: '首页', icon: 'home'}
  //   },
  //   // {
  //   //   name: 'document',
  //   //   path: 'https://www.macrozheng.com',
  //   //   meta: {title: '学习教程', icon: 'document'}
  //   // },
  //   // {
  //   //   name: 'video',
  //   //   path: 'https://www.macrozheng.com/mall/catalog/mall_video.html',
  //   //   meta: {title: '视频教程', icon: 'video'}
  //   // },
  //   ]
  // }
  // {
  // path: '/scholarship/apply',
  // name: 'ScholarshipApply',
  // component: () => import('@/views/scholarship/apply.vue'),
  // hidden: true,  // 不在侧边栏显示
  // meta: { title: '奖学金申请' }
  // },
  // {
  // path: '/scholarship/thanks',
  // name: 'ScholarshipThanks',
  // component: () => import('@/views/scholarship/thanks.vue'),
  // hidden: true,
  // meta: { title: '提交成功' }
  // },
]

export const asyncRouterMap = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard3/index'),
    meta: {title: '首页', icon: 'ums-menu'}
  },
  {
    path: '/tasks',
    component: Layout,
    redirect: '/tasks/task',
    name: 'tasks',
    meta: {title: '工作巡查', icon: 'ums-menu'},
    children: [
      {
        path: 'task',
        name: 'task',
        component: () => import('@/views/task/personalTask'),
        meta: {title: '个人任务', icon: 'product-list'}
      },
      {
        path: 'addTask',
        name: 'addTask',
        component: () => import('@/views/task/add'),
        meta: {title: '添加巡查任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updateTask',
        name: 'updateTask',
        component: () => import('@/views/task/update'),
        meta: {title: '修改巡查任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'reviewTask',
        name: 'reviewTask',
        component: () => import('@/views/task/review'),
        meta: {title: '复查巡查任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'readTaskWithHistory',
        name: 'readTaskWithHistory',
        component: () => import('@/views/task/readWithHistory'),
        meta: {title: '查看历史巡查任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'areaTask',
        name: 'areaTask',
        component: () => import('@/views/areaTask/index'),
        meta: {title: '所属片区任务', icon: 'product-list'}
      },
      {
        path: 'departmentTask',
        name: 'departmentTask',
        component: () => import('@/views/task/departmentIndex'),
        meta: {title: '部门任务', icon: 'product-list'}
      },
      // {
      //   path: 'overallTask',
      //   name: 'overallTask',
      //   component: () => import('@/views/task/overall'),
      //   meta: {title: '汇总任务', icon: 'product-list'}
      // },
      //户管
      {
        path: 'fireFighting',
        name: 'fireFighting',
        component: () => import('@/views/task/huguan/departmentIndex'),
        meta: {title: '户管巡查', icon: 'product-list', keepAlive: true},
        props: {
          departmentId: 4,
          ownerId: 4, 
          type: 2,
        }
      },
      {
        path: 'landlordFormalTask',
        name: 'landlordFormalTask',
        component: () => import('@/views/task/huguan/departmentIndex'),
        meta: {title: '二手房东任务', icon: 'product-list', keepAlive: true},
        props: {
          departmentId: 4,
          ownerId: 4,
          taskSource: 'landlord',
        }
      },
      {
        path: 'reviewHuguanTask',
        name: 'reviewHuguanTask',
        component: () => import('@/views/task/huguan/review'),
        meta: {title: '复查户管巡查任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'readHuguanTaskWithHistory',
        name: 'readHuguanTaskWithHistory',
        component: () => import('@/views/task/huguan/readWithHistory'),
        meta: {title: '查看户管历史巡查任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updateHuguanTask',
        name: 'updateHuguanTask',
        component: () => import('@/views/task/huguan/update'),
        meta: {title: '修改巡查任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updateHuguanRoomTask',
        name: 'updateHuguanRoomTask',
        component: () => import('@/views/task/huguan/components/SubTaskBaseDetail'),
        meta: {title: '修改巡查子任务', icon: 'product-add'},
        hidden: true,
        props: (route) => ({
          id: route.query.id,
          roomId: route.query.roomId,
          taskId: route.query.taskId,
          jobId: route.query.jobId
        })
      },
      //安监任务
      {
        path: 'anjianTask',
        name: 'anjianTask',
        component: () => import('@/views/task/anjian/departmentIndex'),
        meta: {title: '安监巡查', icon: 'product-list'},
        props: {
          departmentId: 3,
          ownerId: 3, 
          type: 2,
        }
      },
      {path: 'updateAnjianTask',
        name: 'updateAnjianTask',
        component: () => import('@/views/task/anjian/update'),
        meta: {title: '修改安监巡查任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'reviewAnjianTask',
        name: 'reviewAnjianTask',
        component: () => import('@/views/task/anjian/review'),
        meta: {title: '复查安监巡查任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'readAnjianTaskWithHistory',
        name: 'readAnjianTaskWithHistory',
        component: () => import('@/views/task/anjian/readWithHistory'),
        meta: {title: '查看安监历史巡查任务', icon: 'product-add'},
        hidden: true
      },
      //城管任务
      {
        path: 'chengguanTask',
        name: 'chengguanTask',
        component: () => import('@/views/task/chengguan/departmentIndex'),
        meta: {title: '城管巡查', icon: 'product-list'},
        props: {
          departmentId: 2,
          ownerId: 2, 
          type: 2,
        },
        // children: [
        //   //危房巡查任务
        //   {
        //     path: 'dilapidatedBuildingTask',
        //     name: 'dilapidatedBuildingTask',
        //     component: () => import('@/views/task/chengguan/departmentIndex'),
        //     meta: {title: '危房巡查', icon: 'product-list'},
        //     props: {
        //       departmentId: 2,
        //       ownerId: 2, 
        //       type: 2,
        //       taskName: '危房巡查'
        //     }
        //   }
        // ]
      },
      //商铺巡查任务
      {
        path: 'shopTask',
        name: 'shopTask',
        component: () => import('@/views/task/chengguan/departmentIndex'),
        meta: {title: '商铺巡查', icon: 'product-list'},
        props: {
          departmentId: 67, //综合执法办
          ownerId: 2, 
          type: 2,
          taskName: '商铺巡查'
        }
      },
      {
        path: 'chengguan/river',
        name: 'updateRiverTask',
        component: () => import('@/views/task/chengguan/river'),
        meta: {title: '修改河涌巡查任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'chengguan/farm',
        name: 'updateFarmTask',
        component: () => import('@/views/task/chengguan/farm'),
        meta: {title: '修改农田巡查任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'chengguan/mountain',
        name: 'updateMountainTask',
        component: () => import('@/views/task/chengguan/mountain'),
        meta: {title: '修改山林巡查任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'chengguan/shop',
        name: 'updateShopTask',
        component: () => import('@/views/task/chengguan/shop'),
        meta: {title: '修改商铺巡查任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'reviewShopTask',
        name: 'reviewShopTask',
        component: () => import('@/views/task/chengguan/reviewShop'),
        meta: {title: '复查商铺巡查任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'readShopTaskWithHistory',
        name: 'readShopTaskWithHistory',
        component: () => import('@/views/task/chengguan/readShopWithHistory'),
        meta: {title: '查看商铺历史巡查任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'chengguan/project',
        name: 'updateProjectTask',
        component: () => import('@/views/task/chengguan/project'),
        meta: {title: '修改临小、零星工程巡查任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'chengguan/update',
        name: 'updateChengguanTask',
        component: () => import('@/views/task/chengguan/update'),
        meta: {title: '修改城管巡查任务', icon: 'product-add'},
        hidden: true
      },
      // 测试页面目录
      {
        path: 'test',
        name: 'test',
        component: Layout,
        meta: {title: '测试页面目录', icon: 'ums-menu'},
        children: [
          {
            path: 'test1',
            name: 'test1',
            component: () => import('@/views/task/personalTask'),
            meta: {title: '测试1页面', icon: 'product-list'}
          },
          {
            path: 'test2',
            name: 'test2',
            component: () => import('@/views/task/personalTask'),
            meta: {title: '测试2页面', icon: 'product-list'}
          }
        ]
      },
    ]
  },
  {
    path: '/jobs',
    component: Layout,
    redirect: '/jobs/job',
    name: 'jobs',
    meta: {title: '工作任务', icon: 'order'},
    children: [{
      path: 'job',
      name: 'job',
      component: () => import('@/views/job/index'),
      meta: {title: '工作任务列表', icon: 'product-list'}
    },
      {
        path: 'addJob',
        name: 'addJob',
        component: () => import('@/views/job/add'),
        meta: {title: '添加工作任务', icon: 'product-add'}
      },
      {
        path: 'updateJob',
        name: 'updateJob',
        component: () => import('@/views/job/update'),
        meta: {title: '修改工作任务', icon: 'product-add'},
        hidden: true
      },
      // {
      //   path: 'addAnnualJob',
      //   name: 'addAnnualJob',
      //   component: () => import('@/views/job/addAnnualJob'),
      //   meta: {title: '添加年度重点任务', icon: 'product-add'}
      // },
      // {
      //   path: 'updateAnnualJob',
      //   name: 'updateAnnualJob',
      //   component: () => import('@/views/job/updateAnnualJob'),
      //   meta: {title: '更新年度重点任务', icon: 'product-add'},
      //   hidden: true
      // },
      {
        path: 'addChengguanJob',
        name: 'addChengguanJob',
        component: () => import('@/views/job/chengguanJob/add'),
        meta: {title: '添加城管工作任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updateChengguanJob',
        name: 'updateChengguanJob',
        component: () => import('@/views/job/chengguanJob/update'),
        meta: {title: '修改城管工作任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'addAnjianJob',
        name: 'addAnjianJob',
        component: () => import('@/views/job/anjianJob/add'),
        meta: {title: '添加安监工作任务', icon: 'product-add'},
        hidden: true
      },
      { path: 'updateAnjianJob',
        name: 'updateAnjianJob',
        component: () => import('@/views/job/anjianJob/update'),
        meta: {title: '修改安监工作任务', icon: 'product-add'},
        hidden: true
      },
      { path: 'addShopJob',
        name: 'addShopJob',
        component: () => import('@/views/job/shopJob/add'),
        meta: {title: '添加商铺巡查任务', icon: 'product-add'},
        hidden: true
      },
      { path: 'updateShopJob',
        name: 'updateShopJob',
        component: () => import('@/views/job/shopJob/update'),
        meta: {title: '修改商铺巡查任务', icon: 'product-add'},
        hidden: true
      },
      { path: 'addDilapidatedBuildingJob',
        name: 'addDilapidatedBuildingJob',
        component: () => import('@/views/job/shopJob/add'),
        meta: {title: '添加危房巡查任务', icon: 'product-add'},
        hidden: true
      },
      { path: 'updateDilapidatedBuildingJob',
        name: 'updateDilapidatedBuildingJob',
        component: () => import('@/views/job/shopJob/update'),
        meta: {title: '修改危房巡查任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'addHuguanJob',
        name: 'addHuguanJob',
        component: () => import('@/views/job/huguanJob/add'),
        meta: {title: '添加户管工作任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'modularPageManage',
        name: 'modularPageManage',
        component: () => import('@/views/modularPage/manage'),
        meta: {title: '年度重点任务列表', icon: 'product-list'}
      },
      {
        path: 'modularPageCreate',
        name: 'modularPageCreate',
        component: () => import('@/views/modularPage/create'),
        meta: {title: '添加年度重点任务', icon: 'product-add'},
        hidden: true
      }
    ]
  },
  {
    path: '/building',
    component: Layout,
    redirect: '/building/address',
    name: 'building',
    meta: {title: '房屋管理', icon: 'order'},
    children: [
      {
        path: 'address',
        name: 'address',
        component: () => import('@/views/building/indexAddress'),
        meta: {title: '房屋管理', icon: 'product-list'},
      },
      {
      path: 'house',
      name: 'house',
      component: () => import('@/views/building/indexHouse'),
      meta: {title: '出租屋管理', icon: 'product-list'},
      props: {buildingType: 1},
      },
      {
        path: 'shop',
        name: 'shop',
        component: () => import('@/views/building/indexShop'),
        meta: {title: '商铺管理', icon: 'product-list'},
        props: {buildingType: 2},
      },
      {
        path: 'factory',
        name: 'factory',
        component: () => import('@/views/building/indexFactory'),
        meta: {title: '企业、厂房管理', icon: 'product-list'},
        props: {buildingType: 3},
      },
      {
        path: 'logistics',
        name: 'logistics',
        component: () => import('@/views/building/indexLogistics'),   
        meta: {title: '物流园管理', icon: 'product-list'},
      },
      {
        path: 'logistics/anfa',
       name: 'anfaLogistics',
        component: () => import('@/views/building/indexLogisticsAnfa'),
        meta: {title: '安发物流园', icon: 'product-list' },
      },
      {
        path: 'logistics/tianzhi',
        name: 'tianzhiLogistics',
        component: () => import('@/views/building/indexLogisticsTianzhi'),
        meta: {title: '天智物流园', icon: 'product-list' },
      },
      {
        path: 'grid',
        name: 'grid',
        component: () => import('@/views/chengguan/grid/index'),
        meta: {title: '网格管理', icon: 'product-list'}
      },
      {
        path: 'alley',
        name: 'alley',
        component: () => import('@/views/building/area/index'),
        meta: {title: '地址管理', icon: 'product-list'},
        hidden: true
      },
      {
        path: 'editAddress',
        name: 'editAddress',
        component: () => import('@/views/building/area/editAddress'),
        meta: {title: '门牌地址管理', icon: 'product-list'},
        hidden: true
      },
      {
        path: 'room',
        name: 'room',
        component: () => import('@/views/building/indexRoom'),
        meta: {title: '出租屋（套）管理', icon: 'ums-menu'}
      },
      {
        path: 'renter',
        name: 'renter',
        component: () => import('@/views/renter/index'),
        meta: {title: '来穗人员管理', icon: 'ums-role'}
      },
      {
        path: 'buildingDetail',
        name: 'buildingDetail',
        component: () => import('@/views/building/BuildingDetail'),
        meta: {title: '房屋详情', icon: 'ums-menu'},
        hidden: true
      },
      {
        path: 'altAddress/:buildingId',
        name: 'altAddress',
        component: () => import('@/views/building/altAddress/index'),
        meta: {title: '相同地址管理', icon: 'ums-menu'},
        hidden: true
      },
      {
        path: 'altAddressManage',
        name: 'altAddressManage',
        component: () => import('@/views/building/altAddress/manage'),
        meta: {title: '相同地址管理', icon: 'ums-menu'},
        hidden: true
      }
    ]
  },
  {
    path: '/department',
    component: Layout,
    redirect: '/department/chengjian',
    name: 'department',
    meta: {title: '部门管理', icon: 'order'},
    children: [
      {
        path: 'jingjishe',
        name: 'jingjishe',
        component: () => import('@/views/department/index'),
        meta: {title: '经济社', icon: 'product-list'},
        props: {depId: 1},
      },
      {
        path: 'chengjian',
        name: 'chengjian',
        component: () => import('@/views/department/index'),
        meta: {title: '城建', icon: 'product-list'},
        props: {depId: 2},
      },
      {
        path: 'anjian',
        name: 'anjian',
        component: () => import('@/views/department/index'),
        meta: {title: '安监', icon: 'product-list'},
        props: {depId: 3},
      },
      {
        path: 'huguan',
        name: 'huguan',
        component: () => import('@/views/department/index'),
        meta: {title: '户管', icon: 'product-list'},
        props: {depId: 4},
      },
      {
        path: 'fenguan',
        name: 'fenguan',
        component: () => import('@/views/department/index'),
        meta: {title: '分管', icon: 'product-list'},
        props: {depId: 5},
      },
      {
        path: 'suifu',
        name: 'suifu',
        component: () => import('@/views/department/index'),
        meta: {title: '穗富', icon: 'product-list'},
        props: {depId: 51},
      },
      
    ]
  },
  {
    path: '/domicile',
    component: Layout,
    redirect: '/domicile/domicileList',
    name: 'domicile',
    meta: {title: '户籍管理', icon: 'order'},
    children: [
      {
        path: 'domicileList',
        name: 'domicileList',
        component: () => import('@/views/domicile/index'),
        meta: {title: '户籍列表', icon: 'product-list'}
      },
      {
        path: 'addDomicile',
        name: 'addDomicile',
        component: () => import('@/views/domicile/add'),
        meta: {title: '添加户籍信息', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updateDomicile',
        name: 'updateDomicile',
        component: () => import('@/views/domicile/update'),
        meta: {title: '修改户籍信息', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'death',
        name: 'death',
        component: () => import('@/views/domicile/death/index'),
        meta: {title: '死亡登记', icon: 'product-list'}
      },
      {
        path: 'birth',
        name: 'birth',
        component: () => import('@/views/domicile/birth/index'),
        meta: {title: '死亡登记', icon: 'product-list'}
      },
      {
        path: 'movein',
        name: 'movein',
        component: () => import('@/views/domicile/movein/index'),
        meta: {title: '死亡登记', icon: 'product-list'}
      },
      {
        path: 'moveout',
        name: 'moveout',
        component: () => import('@/views/domicile/moveout/index'),
        meta: {title: '死亡登记', icon: 'product-list'}
      },
      {
        path: 'division',
        name: 'division',
        component: () => import('@/views/domicile/division/index'),
        meta: {title: '死亡登记', icon: 'product-list'}
      },
      {
        path: 'medical',
        name: 'medical',
        component: () => import('@/views/domicile/medical/index'),
        meta: {title: '合作医疗管理', icon: 'product-list'}
      },
    ]
  },
  {
    path: '/party',
    component: Layout,
    redirect: '/party/partyMember',
    name: 'party',
    meta: {title: '党建管理', icon: 'peoples'},
    children: [
      {
        path: 'partyMember',
        name: 'partyMember',
        component: () => import('@/views/party/member/index'),
        meta: {title: '党员管理', icon: 'peoples'}
      },
      {
        path: 'addPartyMember',
        name: 'addPartyMember',
        component: () => import('@/views/party/member/add'),
        meta: {title: '添加党员信息'},
        hidden: true
      },
      {
        path: 'updatePartyMember',
        name: 'updatePartyMember',
        component: () => import('@/views/party/member/update'),
        meta: {title: '修改党员信息'},
        hidden: true
      }
    ]
  },
  // {
  //   path: '/people',
  //   component: Layout,
  //   // redirect: '/people',
  //   name: 'people',
  //   meta: {title: '人员管理', icon: 'order'},
  //   children: [
  //     {
  //       path: 'renter',
  //       name: 'renter',
  //       component: () => import('@/views/renter/index'),
  //       meta: {title: '来穗人员管理', icon: 'ums-role'}
  //     }
  //   ]
  // },
  {
    path: '/health',
    component: Layout,
    redirect: '/health/healthList',
    name: 'health',
    meta: {title: '卫生（穗富）', icon: 'ums-menu'},
    children: [
      {
        path: 'healthList',
        name: 'healthList',
        component: () => import('@/views/health/departmentIndex'),
        meta: {title: '派单列表', icon: 'product-list'},
        props: (route) => ({
          ownerId: 51, 
          type: 2,
          addTaskUrl: '/health/addHealth',
          createDate: route.query.createDate,
          village: route.query.village,
          switchType: route.query.switchType
        })
      },
      {
        path: 'addHealth',
        name: 'addHealth',
        component: () => import('@/views/health/add'),
        meta: {title: '添加派单', icon: 'product-add'},
        props: {
          name: '环境卫生（穗富）',
          assignedUsers: ['2_51'],
          listTaskUrl: '/health/healthList'
        }
      },
      {
        path: 'updateHealthJob',
        name: 'updateHealthJob',
        component: () => import('@/views/health/updateJob'),
        meta: {title: '编辑任务', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updateHealthTask',
        name: 'updateHealthTask',
        component: () => import('@/views/health/updateTask'),
        meta: {title: '编辑任务', icon: 'product-add'},
        hidden: true
      },
    ]
  },
  {
    path: '/landlord',
    component: Layout,
    redirect: '/landlord/audit',
    name: 'landlord',
    meta: {title: '二手房东', icon: 'form'},
    children: [
      {
        path: 'audit',
        name: 'landlordTaskAudit',
        component: () => import('@/views/landlord/task/audit'),
        meta: {title: '提交审核', icon: 'ums-resource'}
      },
      {
        path: 'bound',
        name: 'landlordBoundTask',
        component: () => import('@/views/landlord/task/bound'),
        meta: {title: '已绑定任务', icon: 'product-list'}
      },
      {
        path: 'fill',
        name: 'landlordTaskFill',
        component: () => import('@/views/landlord/task/fill'),
        meta: {title: '任务填写', icon: 'edit'},
        hidden: true
      },
      {
        path: 'room',
        name: 'landlordRoomTaskFill',
        component: () => import('@/views/task/huguan/components/SubTaskBaseDetail'),
        meta: {title: '房间填写', icon: 'edit'},
        hidden: true,
        props: (route) => ({
          landlordMode: true,
          landlordToken: route.query.token,
          roomId: route.query.roomId,
          id: route.query.id
        })
      },
    ]
  },
  {
    path: '/statistic',
    component: Layout,
    redirect: '/statistic/statisticList',
    name: 'statistic',
    meta: {title: '任务数据汇总', icon: 'statistic'},
    children: [
      // {
      //   path: 'overallTask',
      //   name: 'overallTask',
      //   component: () => import('@/views/statistic/overall'),
      //   meta: {title: '汇总任务', icon: 'product-list'}
      // },
      {
        path: 'statisticList',
        name: 'statisticList',
        component: () => import('@/views/statistic/index'),
        meta: {title: '任务数据汇总', icon: 'statistic'}
      },
      {
        path: 'suifuChart',
        name: 'suifuChart',
        component: () => import('@/views/statistic/suifu/index'),
        meta: {title: '穗富统计', icon: 'statistic-chartable'},
        props: {ownerId: 51, type: 2, path: '/health/healthList'},
      },
      {
        path: 'huguanChart',
        name: 'huguanChart',
        component: () => import('@/views/statistic/huguan/index'),
        meta: {title: '户管统计', icon: 'statistic-chartable'},
        props: {ownerId: 4, type: 2, path: '/tasks/fireFighting'},
      },
      {
        path: 'dengueFeverChart',
        name: 'dengueFeverChart',
        component: () => import('@/views/statistic/suifu/index'),
        meta: {title: '登革热', icon: 'statistic-chartable'},
        props: {ownerId: 1, type: 2, path: '/health/healthList', taskName: '登革热'},
      },
      {
        path: 'housekeepingChart',
        name: 'housekeepingChart',
        component: () => import('@/views/statistic/suifu/index'),
        meta: {title: '房屋卫生', icon: 'statistic-chartable'},
        props: {ownerId: 1, type: 2, path: '/activity/housekeeping', taskName: '房屋卫生专题'},
      },
      {
        path: 'housekeeping2setChart',
        name: 'housekeeping2setChart',
        component: () => import('@/views/statistic/suifu/index'),
        meta: {title: '两件套验收', icon: 'statistic-chartable'},
        props: {ownerId: 1, type: 2, path: '/activity/housekeeping2set', taskName: '两件套验收专题'},
      },
      {
        path: 'rooftopChart',
        name: 'rooftopChart',
        component: () => import('@/views/statistic/suifu/index'),
        meta: {title: '天台验收统计', icon: 'statistic-chartable'},
        props: {ownerId: 1, type: 2, path: '/activity2026/activity2026Rooftop', taskName: '天台验收专题'},
      },
      {
        path: 'loginStatistic',
        name: 'loginStatistic',
        component: () => import('@/views/statistic/login/index'),
        meta: {title: '用户登录分析', icon: 'ums-admin'},
      },
    ]
  },
  // {
  //   path: '/huguanDep',
  //   component: Layout,
  //   redirect: '/huguanDep/huguanDaily',
  //   name: 'huguanDep',
  //   meta: {title: '户管管理', icon: 'product-list'},
  //   children: [
  //     // {
  //     //   path: 'huguanDaily',
  //     //   name: 'huguanDaily',
  //     //   component: () => import('@/views/task/departmentIndex'),
  //     //   meta: {title: '日常巡查', icon: 'product-list'},
  //     //   props: {
  //     //     ownerId: 4, 
  //     //     type: 2,
  //     //     taskName: '日常巡查'
  //     //   },
  //     //   hidden: true
  //     // },
  //     {
  //       path: 'fireFighting',
  //       name: 'fireFighting',
  //       component: () => import('@/views/task/departmentIndex'),
  //       meta: {title: '户管巡查', icon: 'product-list'},
  //       props: {
  //         ownerId: 4, 
  //         type: 2,
  //         taskName: '出租屋安全设施“十件套”'
  //       }
  //     },
  //   ]
  // },
  {
    path: '/assets',
    component: Layout,
    redirect: '/assets/activityList',
    name: 'assets',
    meta: {title: '三资管理', icon: 'product-list'},
    children: [
      {
        path: 'activityList',
        name: 'activityList',
        component: () => import('@/views/activity/flowIndex'),
        meta: {title: '三资管理', icon: 'activity', keepAlive: true},
        props: {
          moduleId: 2
        }
      },
      //todo 这种有权限分配问题，因为目录也是权限分配的一个，不应该在里面 20251026
      // {
      //   path: 'assetsList',
      //   name: 'assetsList',
      //   meta: {title: '经济社三资', icon: 'product-list'},
      //   component: {
      //     template: '<router-view></router-view>' // 只提供路由出口
      //   },
      //   children: [
      //     {
      //       path: 'assetsUnit1',
      //       name: 'assetsUnit1',
      //       component: () => import('@/views/activity/flowIndex'),
      //       meta: {title: '一社三资管理', icon: 'product-list'},
      //       props: {
      //         moduleId: 2,
      //         unit: 2
      //       }
      //     }, 
      //     {
      //       path: 'assetsUnit2',
      //       name: 'assetsUnit2',
      //       component: () => import('@/views/activity/flowIndex'),
      //       meta: {title: '二社三资管理', icon: 'product-list'},
      //       props: {
      //         moduleId: 2,
      //         unit: 2
      //       }
      //     }, 
      //   ]
      // },
      
      {
        path: 'assetsModuleList',
        name: 'assetsModuleList',
        component: () => import('@/views/activity/flowTemplateIndex'),
        meta: {title: '模板管理', icon: 'activity'},
        props: {
          moduleId: 1
        }
      },
      {
        path: 'addActivity',
        name: 'addActivity',
        component: () => import('@/views/activity/add'),
        meta: {title: '添加', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updateActivity',
        name: 'updateActivity',
        component: () => import('@/views/activity/update'),
        meta: {title: '编辑', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'addFlow',
        name: 'addFlow',
        component: () => import('@/views/flow/add'),
        meta: {title: '节点图添加', icon: 'product-add'},
        props: {
          moduleId: 2
        },
        hidden: true,
      },
      {
        path: 'updateFlow',
        name: 'updateFlow',
        component: () => import('@/views/flow/update'),
        meta: {title: '节点图更新', icon: 'product-add'},
        props: {
          moduleId: 2
        },
        hidden: true
      },
      {
        path: 'addModule',
        name: 'addModule',
        component: () => import('@/views/flow/add'),
        meta: {title: '节点图添加', icon: 'product-add'},
        props: {
          moduleId: 1
        },
        hidden: true
      },
      {
        path: 'updateModule',
        name: 'updateModule',
        component: () => import('@/views/flow/update'),
        meta: {title: '节点图更新', icon: 'product-add'},
        props: {
          moduleId: 1
        },
        hidden: true
      },
      {
        path: 'updateNode',
        name: 'updateNode',
        component: () => import('@/views/activity/updateNode'),
        meta: {title: '节点更新', icon: 'product-add'},
        props: {
          moduleId: 2
        },
        hidden: true
      },
      {
        path: 'updateTemplateNode',
        name: 'updateTemplateNode',
        component: () => import('@/views/activity/updateTemplateNode'),
        meta: {title: '节点更新', icon: 'product-add'},
        props: {
          moduleId: 1
        },
        hidden: true
      },
      {
        path: 'updateEdge',
        name: 'updateEdge',
        component: () => import('@/views/activity/updateEdge'),
        meta: {title: '连线更新', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'files/:path*',
        name: 'files',
        component: () => import('@/views/files/index'),
        meta: {title: '文档管理', icon: 'product-list'},
        beforeEnter: (to, from, next) => {
          //todo 20250406 这里有个跳转bug,进入页面后再重新点击页签url会有问题
          // 如果URL包含匹配模式，重定向到干净URL
          if(to.path.includes(':path*')) {
            next(to.path.replace(':path*', ''))
          } else {
            next()
          }
        }
      },
      {
        path: 'fund',
        name: 'fund',
        component: () => import('@/views/assets/fund'),
        meta: {title: '专项资金表', icon: 'product-add'},
      },
      {
        path: 'addFund',
        name: 'addFund',
        component: () => import('@/views/assets/fund/add'),
        meta: {title: '添加专项资金', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'updateFund',
        name: 'updateFund',
        component: () => import('@/views/assets/fund/update'),
        meta: {title: '编辑专项资金', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'fundDetail',
        name: 'fundDetail',
        component: () => import('@/views/assets/fund/detail'),
        meta: {title: '专款去向', icon: 'product-add'},
        hidden: true
      },
      {
      path: 'scholarship',
      name: 'scholarship',
      component: () => import('@/views/activity/scholarship/index'),
      meta: { title: '奖学金管理', icon: 'product-list' }
      },
      {
      path: 'conversation',
      name: 'ConversationDetail',
      component: () => import('@/views/assets/conversation/index'),
      meta: { title: '三资平台对话', icon: 'el-icon-chat-dot-round' },
      hidden: true, 
      },
      {
      path: 'topicList',
      name: 'ConversationTopicList',
      component: () => import('@/views/assets/conversation/TopicList'),
      meta: { title: '三资平台对话', icon: 'el-icon-chat-dot-round' }
    }
    ]
  },
  {
    path: '/activity',
    component: Layout,
    redirect: '/activity/dengueFever',
    name: 'activity',
    meta: {title: '年度重点专题', icon: 'activity'},
    children: [
      // {
      //   path: 'fireFighting',
      //   name: 'fireFighting',
      //   component: () => import('@/views/task/departmentIndex'),
      //   meta: {title: '十件套', icon: 'product-list'},
      //   // props: (route) => ({
      //   //   ownerId: 4, 
      //   //   type: 2,
      //   //   createDate: route.query.createDate,
      //   //   village: route.query.village,
      //   //   switchType: route.query.switchType
      //   // })
      //   props: {
      //     ownerId: 4, 
      //     type: 2,
      //     taskName: '出租屋安全设施“十件套”'
      //   }
      // },
      
      {
        path: 'dengueFever',
        name: 'dengueFever',
        component: () => import('@/views/health/departmentIndex'),
        meta: {title: '登革热专题', icon: 'product-list'},
        props: (route) => ({
          ownerId: 1, 
          type: 2,
          taskName: '登革热',
          addTaskUrl: '/activity/addDengueFever',
          createDate: route.query.createDate,
          village: route.query.village,
          switchType: route.query.switchType
        })
      },
      {
        path: 'addDengueFever',
        name: 'addDengueFever',
        component: () => import('@/views/health/add'),
        meta: {title: '添加派单', icon: 'product-add'},
        props: {
          name: '登革热',
          assignedUsers: ['2_1'],
          listTaskUrl: '/activity/dengueFever'
        },
        hidden: true
      },
      {
        path: 'dengueFeverDocument',
        name: 'dengueFeverDocument',
        component: () => import('@/views/files/reportIndex'),
        meta: {title: '登革热', icon: 'product-add'},
        props: { depName: '登革热', year: 2025, title: '登革热'},
        hidden: true
      },
      {
        path: 'housekeeping',
        name: 'housekeeping',
        component: () => import('@/views/activity/housekeeping/departmentIndex'),
        meta: {title: '房屋卫生专题', icon: 'product-list'},
        props: (route) => ({
          ownerId: 1, //经济社
          type: 2,
          taskName: '房屋卫生专题',
          addTaskUrl: '/activity/addHousekeeping',
          createDate: route.query.createDate,
          village: route.query.village,
          switchType: route.query.switchType
        })
      },
      {
        path: 'addHousekeeping',
        name: 'addHousekeeping',
        component: () => import('@/views/activity/housekeeping/addTask'),
        meta: {title: '添加房屋验收任务', icon: 'product-add'},
        props: {
          ownerId: 1, 
          type: 2,
          taskName: '房屋卫生专题',
        },
        hidden: true
      },
      {
        path: 'updateHousekeeping',
        name: 'updateHousekeeping',
        component: () => import('@/views/activity/housekeeping/updateTask'),
        meta: {title: '编辑房屋验收任务', icon: 'product-add'},
        props: {
          ownerId: 1, 
          type: 2,
          taskName: '房屋卫生专题',
        },
        hidden: true
      },
      {
        path: 'housekeeping2set',
        name: 'housekeeping2set',
        component: () => import('@/views/activity/housekeeping2set/departmentIndex'),
        meta: {title: '两件套验收专题', icon: 'product-list'},
        props: (route) => ({
          ownerId: 1, //经济社
          type: 2,
          taskName: '两件套验收专题',
          addTaskUrl: '/activity/addHousekeeping2set',
          createDate: route.query.createDate,
          village: route.query.village,
          switchType: route.query.switchType
        })
      },
      {
        path: 'addHousekeeping2set',
        name: 'addHousekeeping2set',
        component: () => import('@/views/activity/housekeeping2set/addTask'),
        meta: {title: '添加两件套验收任务', icon: 'product-add'},
        props: {
          ownerId: 1, 
          type: 2,
          taskName: '两件套验收专题',
        },
        hidden: true
      },
      {
        path: 'updateHousekeeping2set',
        name: 'updateHousekeeping2set',
        component: () => import('@/views/activity/housekeeping2set/updateTask'),
        meta: {title: '编辑两件套验收任务', icon: 'product-add'},
        props: {
          ownerId: 1, 
          type: 2,
          taskName: '两件套验收专题',
        },
        hidden: true
      },
      // {
      //   path: 'annual_2025_1',
      //   name: 'annual_2025_1',
      //   component: () => import('@/views/files/reportIndex'),
      //   meta: {title: '三清三拆', icon: 'product-add'},
      //   props: { depName: '三资办', year: 2025, title: '三清三拆'}
      // },
    ]
  },
  // {
  //   path: '/document',
  //   component: Layout,
  //   redirect: '/document/files/',
  //   name: 'document',
  //   meta: {title: '文档管理', icon: 'order'},
  //   children: [
  //     {
  //       path: 'files/:path*',
  //       name: 'files',
  //       component: () => import('@/views/files/index'),
  //       meta: {title: '文档管理', icon: 'product-list'},
  //       beforeEnter: (to, from, next) => {
  //         //todo 20250406 这里有个跳转bug,进入页面后再重新点击页签url会有问题
  //         // 如果URL包含匹配模式，重定向到干净URL
  //         if(to.path.includes(':path*')) {
  //           next(to.path.replace(':path*', ''))
  //         } else {
  //           next()
  //         }
  //       }
  //     }
  //   ]
  // },
  // 2026年度重点专题
  {
    path: '/activity2026',
    name: 'activity2026',
    redirect: '/activity2026/houseFrontBackGroup/activity2026Alley',
    component: Layout,
    meta: {title: '2026年度重点专题', icon: 'ums-menu'},
    children: [
      {
        path: 'houseFrontBackGroup',
        name: 'houseFrontBackGroup',
        component: { template: '<router-view></router-view>' },
        meta: {title: '房前屋后专题', icon: 'product-list'},
        alwaysShow: true,
        children: [
          {
            path: 'activity2026Alley',
            name: 'activity2026Alley',
            component: () => import('@/views/activity/2026/alley/departmentIndex'),
            meta: {title: '背街冷巷专题', icon: 'product-list'},
            props: (route) => ({
              ownerId: 1,
              type: 2,
              taskName: '背街冷巷专题',
              addTaskUrl: '/activity2026/houseFrontBackGroup/activity2026AlleyAdd',
              createDate: route.query.createDate,
              village: route.query.village,
              switchType: route.query.switchType
            })
          },
          {
            path: 'activity2026AlleyAdd',
            name: 'activity2026AlleyAdd',
            component: () => import('@/views/activity/2026/alley/addTask'),
            meta: {title: '添加背街冷巷任务', icon: 'product-add'},
            props: {
              ownerId: 1,
              type: 2,
              taskName: '背街冷巷专题',
            },
            hidden: true
          },
          {
            path: 'activity2026AlleyUpdate',
            name: 'activity2026AlleyUpdate',
            component: () => import('@/views/activity/2026/alley/updateTask'),
            meta: {title: '编辑背街冷巷任务', icon: 'product-add'},
            props: {
              ownerId: 1,
              type: 2,
              taskName: '背街冷巷专题',
            },
            hidden: true
          },
          {
            path: 'activity2026HouseFrontBack',
            name: 'activity2026HouseFrontBack',
            component: () => import('@/views/activity/2026/houseFrontBack/departmentIndex'),
            meta: {title: '杂物清理专题', icon: 'product-list'},
            props: (route) => ({
              ownerId: 1,
              type: 2,
              taskName: '杂物清理专题',
              addTaskUrl: '/activity2026/houseFrontBackGroup/activity2026HouseFrontBackAdd',
              createDate: route.query.createDate,
              village: route.query.village,
              switchType: route.query.switchType
            })
          },
          {
            path: 'activity2026VacantLand',
            name: 'activity2026VacantLand',
            component: () => import('@/views/activity/2026/vacantLand/departmentIndex'),
            meta: {title: '闲置空地专题', icon: 'product-list'},
            props: (route) => ({
              ownerId: 1,
              type: 2,
              taskName: '闲置空地专题',
              addTaskUrl: '/activity2026/houseFrontBackGroup/activity2026VacantLandAdd',
              createDate: route.query.createDate,
              village: route.query.village,
              switchType: route.query.switchType
            })
          },
          
          {
            path: 'activity2026HouseFrontBackAdd',
            name: 'activity2026HouseFrontBackAdd',
            component: () => import('@/views/activity/2026/houseFrontBack/addTask'),
            meta: {title: '添加杂物清理任务', icon: 'product-add'},
            props: {
              ownerId: 1,
              type: 2,
              taskName: '杂物清理专题',
            },
            hidden: true
          },
          {
            path: 'activity2026HouseFrontBackUpdate',
            name: 'activity2026HouseFrontBackUpdate',
            component: () => import('@/views/activity/2026/houseFrontBack/updateTask'),
            meta: {title: '编辑杂物清理任务', icon: 'product-add'},
            props: {
              ownerId: 1,
              type: 2,
              taskName: '杂物清理专题',
            },
            hidden: true
          },
          
          {
            path: 'activity2026VacantLandAdd',
            name: 'activity2026VacantLandAdd',
            component: () => import('@/views/activity/2026/vacantLand/addTask'),
            meta: {title: '添加闲置空地任务', icon: 'product-add'},
            props: {
              ownerId: 1,
              type: 2,
              taskName: '闲置空地专题',
            },
            hidden: true
          },
          {
            path: 'activity2026VacantLandUpdate',
            name: 'activity2026VacantLandUpdate',
            component: () => import('@/views/activity/2026/vacantLand/updateTask'),
            meta: {title: '编辑闲置空地任务', icon: 'product-add'},
            props: {
              ownerId: 1,
              type: 2,
              taskName: '闲置空地专题',
            },
            hidden: true
          }
        ]
      },
      {
        path: 'activity2026ThreePackets',
        name: 'activity2026ThreePackets',
        component: () => import('@/views/activity/2026/threePackets/departmentIndex'),
        meta: {title: '门前三包专题', icon: 'product-list'},
        props: (route) => ({
          ownerId: 1,
          type: 2,
          taskName: '门前三包专题',
          addTaskUrl: '/activity2026/activity2026ThreePacketsAdd',
          createDate: route.query.createDate,
          village: route.query.village,
          switchType: route.query.switchType
        })
      },
      {
        path: 'activity2026MountainGovernance',
        name: 'activity2026MountainGovernance',
        component: () => import('@/views/activity/2026/houseFrontBack/departmentIndex'),
        meta: {title: '山体滑坡治理', icon: 'product-list'},
        props: (route) => ({
          ownerId: 1,
          type: 2,
          taskName: '山体滑坡治理',
          addTaskUrl: '/activity2026/activity2026MountainGovernanceAdd',
          createDate: route.query.createDate,
          village: route.query.village,
          switchType: route.query.switchType
        })
      },
      {
        path: 'activity2026MountainGovernanceAdd',
        name: 'activity2026MountainGovernanceAdd',
        component: () => import('@/views/activity/2026/houseFrontBack/addTask'),
        meta: {title: '添加山体滑坡治理', icon: 'product-add'},
        props: {
          ownerId: 1,
          type: 2,
          taskName: '山体滑坡治理',
        },
        hidden: true
      },
      {
        path: 'activity2026MountainGovernanceUpdate',
        name: 'activity2026MountainGovernanceUpdate',
        component: () => import('@/views/activity/2026/houseFrontBack/updateTask'),
        meta: {title: '编辑山体滑坡治理', icon: 'product-add'},
        props: {
          ownerId: 1,
          type: 2,
          taskName: '山体滑坡治理',
        },
        hidden: true
      },
      {
        path: 'activity2026ThreePacketsAdd',
        name: 'activity2026ThreePacketsAdd',
        component: () => import('@/views/activity/2026/threePackets/addTask'),
        meta: {title: '添加门前三包任务', icon: 'product-add'},
        props: {
          ownerId: 1,
          type: 2,
          taskName: '门前三包专题',
        },
        hidden: true
      },
      {
        path: 'activity2026ThreePacketsUpdate',
        name: 'activity2026ThreePacketsUpdate',
        component: () => import('@/views/activity/2026/threePackets/updateTask'),
        meta: {title: '编辑门前三包任务', icon: 'product-add'},
        props: {
          ownerId: 1,
          type: 2,
          taskName: '门前三包专题',
        },
        hidden: true
      },
      {
        path: 'activity2026VacantHouse',
        name: 'activity2026VacantHouse',
        component: () => import('@/views/activity/2026/vacantHouse/departmentIndex'),
        meta: {title: '空置房屋专题', icon: 'product-list'},
        props: (route) => ({
          ownerId: 1,
          type: 2,
          taskName: '空置房屋专题',
          addTaskUrl: '/activity2026/activity2026VacantHouseAdd',
          createDate: route.query.createDate,
          village: route.query.village,
          switchType: route.query.switchType
        })
      },
      // 天台验收专题
      {
        path: 'activity2026Rooftop',
        name: 'activity2026Rooftop',
        component: () => import('@/views/activity/2026/rooftop/departmentIndex'),
        meta: {title: '天台验收专题', icon: 'product-list'},
        props: (route) => ({
          ownerId: 1,
          type: 2,
          taskName: '天台验收专题',
          addTaskUrl: '/activity2026/activity2026RooftopAdd',
          createDate: route.query.createDate,
          village: route.query.village,
          switchType: route.query.switchType
        })
      },
      // 空置房屋专题 - 添加任务
      {
        path: 'activity2026VacantHouseAdd',
        name: 'activity2026VacantHouseAdd',
        component: () => import('@/views/activity/2026/vacantHouse/addTask'),
        meta: {title: '添加空置房屋任务', icon: 'product-add'},
        props: {
          ownerId: 1,
          type: 2,
          taskName: '空置房屋专题',
        },
        hidden: true
      },
      // 空置房屋专题 - 编辑任务
      {
        path: 'activity2026VacantHouseUpdate',
        name: 'activity2026VacantHouseUpdate',
        component: () => import('@/views/activity/2026/vacantHouse/updateTask'),
        meta: {title: '编辑空置房屋任务', icon: 'product-add'},
        props: {
          ownerId: 1,
          type: 2,
          taskName: '空置房屋专题',
        },
        hidden: true
      },
      // 天台验收专题 - 添加任务
      {
        path: 'activity2026RooftopAdd',
        name: 'activity2026RooftopAdd',
        component: () => import('@/views/activity/2026/rooftop/addTask'),
        meta: {title: '添加天台验收任务', icon: 'product-add'},
        props: {
          ownerId: 1,
          type: 2,
          taskName: '天台验收专题',
        },
        hidden: true
      },
      // 天台验收专题 - 编辑任务
      {
        path: 'activity2026RooftopUpdate',
        name: 'activity2026RooftopUpdate',
        component: () => import('@/views/activity/2026/rooftop/updateTask'),
        meta: {title: '编辑天台验收任务', icon: 'product-add'},
        props: {
          ownerId: 1,
          type: 2,
          taskName: '天台验收专题',
        },
        hidden: true
      }
    ]
  },
  {
    path: '/chengguan',
    component: Layout,
    redirect: '/chengguan/river',
    name: 'chengguan',
    meta: {title: '城管管理', icon: 'ums-menu'},
    children: [
      {
        path: 'river',
        name: 'river',
        component: () => import('@/views/chengguan/river/index'),
        meta: {title: '河涌管理', icon: 'product-list'}
      },
      {
        path: 'farm',
        name: 'farm',
        component: () => import('@/views/chengguan/farm/index'),
        meta: {title: '农田管理', icon: 'product-list'}
      },
      {
        path: 'dilapidatedBuilding',
        name: 'dilapidatedBuilding',
        component: () => import('@/views/chengguan/dilapidatedBuilding/index'),
        meta: {title: '危房管理', icon: 'product-list'}
      },
      {
        path: 'mountain',
        name: 'mountain',
        component: () => import('@/views/chengguan/mountain/index'),
        meta: {title: '山体管理', icon: 'product-list'}
      },
      {
      path: 'sanitation-fee',
      name: 'sanitation-fee',
      component: () => import('@/views/chengguan/sanitation-fee/index'),
      meta: {title: '卫生费管理', icon: 'product-list'}
      }, 
    ]
  },
  {
    path: '/huguanMenu',
    component: Layout,
    redirect: '/huguanMenu/hgElectricity',
    name: 'huguanMenu',
    meta: {title: '户管', icon: 'ums-menu'},
    children: [
      {
        path: 'hgElectricity',
        name: 'hgElectricity',
        component: () => import('@/views/huguan/hgElectricity/index'),
        meta: {title: '智慧用电', icon: 'product-list'}
      },
      {
        path: 'smokeDetector',
        name: 'smokeDetector',
        component: () => import('@/views/huguan/smokeDetector/index'),
        meta: {title: '智慧烟感器', icon: 'product-list'}
      }
    ]
  },
  {
    path: '/map',
    component: Layout,
    redirect: '/map/chaoyang1Map',
    name: 'map',
    meta: {title: '数据地图', icon: 'order'},
    children: [
      {
        path: 'chaoyang1Map',
        name: 'chaoyang1Map',
        component: () => import('@/views/map/testOL'),
        meta: {title: '地图', icon: 'map'}
      }
    ]
  },
  {
    path: '/reservation',
    component: Layout,
    redirect: '/reservation/meeting',
    name: 'reservation',
    meta: {title: '预约管理', icon: 'reservation'},
    children: [{
      path: 'meeting',
      name: 'meeting',
      component: () => import('@/views/meeting/index'),
      meta: {title: '会议预约', icon: 'meeting'}
    }],
  },

  // {
  //   path: '/modularPage',
  //   component: Layout,
  //   redirect: '/modularPage/create',
  //   name: 'modularPage',
  //   meta: {title: '模块化页面创建', icon: 'ums-menu'},
  //   children: [
  //     {
  //       path: 'create',
  //       name: 'modularPageCreate',
  //       component: () => import('@/views/modularPage/create'),
  //       meta: {title: '页面创建', icon: 'product-add'}
  //     },
  //     {
  //       path: 'manage',
  //       name: 'modularPageManage',
  //       component: () => import('@/views/modularPage/manage'),
  //       meta: {title: '模块化页面管理', icon: 'product-list'}
  //     }
  //   ]
  // },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'userGroup',
        name: 'userGroup',
        component: () => import('@/views/ums/userGroup/index'),
        meta: {title: '组用户列表', icon: 'product-list'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

const createRouter = () => new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router




// WEBPACK FOOTER //
// ./src/router/index.js